import { PackageIcon, FileTextIcon, MapIcon, GlobeIcon, FolderOpenIcon, ShieldCheckIcon } from 'lucide-react';
import type { NavigationSectionConfig } from './types';

/**
 * Products & Templates Navigation Section
 */
export const productsTemplatesSections: NavigationSectionConfig[] = [
  {
    id: 'products-templates-section',
    label: 'Products & Templates',
    topNavId: 'products-templates',
    items: [
      {
        id: 'products',
        label: 'Products',
        path: '/admin/products',
        icon: <PackageIcon size={18} />,
        permissions: ['nav:products']
      },
      {
        id: 'coverage-management',
        label: 'Coverage Management',
        path: '/admin/coverage',
        icon: <ShieldCheckIcon size={18} />,
        permissions: ['nav:coverage']
      },
      {
        id: 'document-templates',
        label: 'Document Templates',
        path: '/admin/document-templates',
        icon: <FileTextIcon size={18} />,
        permissions: ['nav:document-templates']
      },
      {
        id: 'shapefiles',
        label: 'Shapefiles',
        path: '/admin/shapefiles',
        icon: <MapIcon size={18} />,
        permissions: ['nav:shapefiles']
      },
      {
        id: 'administrative-units',
        label: 'Administrative Units',
        path: '/admin/administrative-units',
        icon: <GlobeIcon size={18} />,
        permissions: ['nav:administrative-units']
      },
      {
        id: 'files',
        label: 'CHIRPS Files',
        path: '/admin/files',
        icon: <FolderOpenIcon size={18} />,
        permissions: ['nav:files']
      }
    ]
  }
];

